import { _utilities } from '../utilities.js';
import { _data, _tyresSpecs, VehicleClassWheelPlan } from './data.tyre.js';
import Common from '../i247.Common.js';

class WheelPlans {
	// --------------------------------------------------
	// CONSTRUCTOR
	// --------------------------------------------------

	constructor() {
		this._wheelShapeOriginalColor = undefined;
		this._wheelShapes = undefined;
		this._wheelPlan = undefined;
	}

	// --------------------------------------------------
	// GETTER AND SETTER
	// --------------------------------------------------

	// --------------------------------------------------
	// 'PRIVATE' FUNCTIONS
	// --------------------------------------------------

	BindControls() {
		let _this = this;
		$('input[name="WheelPlan"], .selectWheelPlanBtn').off();
		$('input[name="WheelPlan"]').on('change', function () {
			_data.vehicle.wheelPlan = $(this).filter(':checked').val();
			$('#selectedTyresContainer').empty();
			_this.ShowDiagramSelection(_data.vehicle.wheelPlan, $(this).filter(':checked').next('label').text(), false);
		});
		$('.selectWheelPlanBtn').on('click', function (e) {
			$('.wheel-plan-container').removeClass('tyreDetailInvalid');
			e.preventDefault();
			_data.vehicle.wheelPlan = $(e.target).parents('.wheel-plan-container').data('wheelplanid');
			_this.ShowDiagramSelection(_data.vehicle.wheelPlan, true);
			Common.RemoveValidationStyles(undefined, $(this).closest('[id^="wheelPlanSection"]'));
		});

		$('.changeSpareRadio').on('change', function(args) {
			let $nextbutton = $('.nextButton');
			if (this.checked) {
				$nextbutton.show();				
				_this._wheelPlan.SPARE.Selected = 1;
				Common.RemoveValidationStyles(undefined, $(args.target).closest('.wheel-plan-container'));
			} else {
				_this._wheelPlan.SPARE.Selected = 0;
			}
		});
	};

	BuildWheelPlanDom() {
		return new Promise((resolve, reject) => {
			// TODO: reshape the getWheelplan methods and objects, done it quickly to implement Recaptcha properly.
			let { vehicleMileage: mileage, vehicleId: id, vehicleReg: registration, vehicleMake: make, vehicleModel: description } = _data.vehicle.vehicleDetails;
			$.post("tyres/UpdateVehicleWheelPlan", { "mileage": mileage, "id": id, "registration": registration, "make": make, "description": description })
				.done((updatedVehicle) => {
					let responseObject = updatedVehicle ? JSON.parse(updatedVehicle) : null;
					let vehicleWheelPlans = responseObject ? responseObject.WheelPlans.filter(w => w.Name) : null;

					// WheelPlans header
					let wheelplansHeaderTemplate = $('#wheelPlanHeaderTemplate').html();
					Mustache.parse(wheelplansHeaderTemplate);
					let noWheelPlan = !vehicleWheelPlans;
					let wheelPlanHeader = (vehicleWheelPlans && vehicleWheelPlans.length > 0);
					let renderedHeaderWheelplan = Mustache.render(wheelplansHeaderTemplate, {
						"noWheelPlan": noWheelPlan,
						"wheelPlanHeader": wheelPlanHeader
					});

					$('#wheelPlanHeaderContainer').html(renderedHeaderWheelplan);

					if (!vehicleWheelPlans) return resolve();

					// Add wheelplan index and active class for previous code compatibility
					let vehicleWheelPlansIndexed = vehicleWheelPlans.map((plan, index) => {
						plan.index = index + 1;
						plan.active = (plan.Id === 1 ? 'active' : 'inactive');
						return plan;
					});

					// Radio Buttons template
					let wheelplansRadiosbtnTemplate = $('#wheelPlanRadioBtnTemplate').html();
					Mustache.parse(wheelplansRadiosbtnTemplate);
					let renderedRadioBtnWheelplan = Mustache.render(wheelplansRadiosbtnTemplate, { "wheelplans": vehicleWheelPlansIndexed });

					$('#wheelPlanRadioButtonContainer').html(renderedRadioBtnWheelplan);

					// Wheelplan Images containers template
					let spareTyreImagePath = '/images/Tyres/spareTyreicon.png';
					let wheelplansTemplate = $('#wheelPlanTemplate').html();
					Mustache.parse(wheelplansTemplate);
					let renderedWheelplan = Mustache.render(wheelplansTemplate, { "wheelplans": vehicleWheelPlansIndexed, "spareTyreImage": spareTyreImagePath });

					$('#wheelPlansContainer').html(renderedWheelplan);

					resolve();
				})
				.fail(() => {

					// WheelPlans header
					let wheelplansHeaderTemplate = $('#wheelPlanHeaderTemplate').html();
					Mustache.parse(wheelplansHeaderTemplate);
					let renderedHeaderWheelplan = Mustache.render(wheelplansHeaderTemplate, {
						"noWheelPlan": true,
						"wheelPlanHeader": false
					});

					$('#wheelPlanHeaderContainer').html(renderedHeaderWheelplan);

					reject();
				});
		});
	}

	InitialiseWheelPlanImages() {
		let _this = this;

		if (_data.vehicle.class.toUpperCase() === 'CAR') {
			$('.tyre-wheelPlan-Column').addClass('d-none');
			_this.SelectCarWheelPlan();

			var viewport = $(window).width();
			if (viewport < 767.98) {
				$('#wheelPlanCarouselContainer').removeClass('d-none');

				if ($('.carousel-inner .tyre-wheelPlan-Column').length > 0) {
					$('.carousel-inner .tyre-wheelPlan-Column').removeClass('d-none active');
				} else {
					$('.tyre-wheelPlan-Column').prependTo($('.carousel-inner'))
						.addClass('carousel-item')
						.removeClass('offset-2 col-8 offset-md-0 col-md-6 col-lg-4 d-none active');
				}

				$($('.tyre-wheelPlan-Column')[0])
					.addClass('active');
			}
		} else {
			$('[name="WheelPlan"]').each(function (index, planElement) {
				var $wheelPlanName = $(planElement).next('label').text();
				var $wheelPlanDomlabel = $(planElement).attr('data-label');

				if (!$wheelPlanName) return;

				if (_data.vehicle.class.toUpperCase() == 'STANDARD CAR' || _data.vehicle.class.toUpperCase() == 'LCV') {
					_this.LoadWheelPlanImage($(planElement).val(), $wheelPlanName, $('#' + $wheelPlanDomlabel + 'ImageContainer'))
						.then(() => { _this.FilterWheelplanSelection(_data.vehicle.class, $wheelPlanName) });
				} else {
					_this.LoadWheelPlanImage($(planElement).val(), $wheelPlanName, $('#' + $wheelPlanDomlabel + 'ImageContainer'))
				}
			});
		}
	};

	SelectCarWheelPlan() {
		let _this = this;
		let $StandardCarWheelPlan = $('[name="WheelPlan"][data-label="StandardCar"]');
		let $wheelPlanDomlabel = $StandardCarWheelPlan.attr('data-label');
		let $wheelPlanName = $StandardCarWheelPlan.next('label').text();
		
		_this.LoadWheelPlanImage($StandardCarWheelPlan.val(), $wheelPlanName, $('#' + $wheelPlanDomlabel + 'ImageContainer'))
			.then(() => { _this.FilterWheelplanSelection(_data.vehicle.class, $wheelPlanName) });
	}

	FilterWheelplanSelection(vehicleClass, wheelplanName) {
		if (!vehicleClass || !wheelplanName) return;

		if (vehicleClass.toUpperCase() === 'CAR' && wheelplanName.toUpperCase() === 'STANDARD CAR') {
			var $carselectbutton = $('#StandardCarDiagramContainer').find('.selectWheelPlanBtn');
			$carselectbutton.trigger('click');
		} else if (vehicleClass.toUpperCase() === 'LCV' && wheelplanName.toUpperCase().substring(wheelplanName.length - 3) === 'VAN') {
			$('#StandardCarDiagramContainer').hide();
		}
	}

	LoadWheelPlanImage(wheelPlanId, wheelPlanName, target) {
		let _this = this;

		return new Promise((resolve, reject) => {
			// Exit if we don't have a valid wheel plan or the image already exist
			var isValidWheelPlanId = wheelPlanId && $.isNumeric(parseInt(wheelPlanId));
			var imageAlreadyDisplayed = target.find('svg').length > 0;

			if (!isValidWheelPlanId || imageAlreadyDisplayed) {
				return;
			}
			// Load image. IE renders dynamically created SVG in black, so we load image for IE using
			// an IFRAME, accepting that tooltips don't work
			var wheelPlanImage = _this.GetWheelPlanImageName(wheelPlanId);
			target.empty();
			$.ajax({
				type: 'GET',
				cache: false,
				url: '/images/tyres/' + wheelPlanImage,
				success: function (svg) {
					var importedSVGRootElement = document.importNode(svg.documentElement, true);
					target.append(importedSVGRootElement);

					var svgElement = target.find('svg');
					var isWheelPlanImage = wheelPlanImage !== 'no_image_available.svg';
					if (svgElement && isWheelPlanImage) {
						if (!_utilities.IsInternetExplorer()) {
							svgElement.css('height', '100%');
						} else {
							svgElement.css('height', '400px');
						}

						$(svgElement).addClass('img-fluid');
					}
					return resolve();
				},
				error: function (error) {
					reject(error);
				}
			});

			_this.ActivateWheelPlan(wheelPlanId, wheelPlanName, target);
		});
	};

	ResetWheelShapes() {
		let _this = this;
		$(_this._wheelShapes).off();
		$.each(_this._wheelShapes, function (index, wheel) {
			$(wheel).css('fill', _this._wheelShapeOriginalColor);
		});
	};

	GetWheelShapes(target, selector) {
		return target.find(selector);
	};

	UpdateImageTitle(text) {
		let title = $('svg title');
		if (title) {
			title.text(text);
		}
	};

	UpdateWheelPlanIdAndName(wheelPlanId, wheelPlanName, target) {
		// Overlay wheel plan name and title
		target.parents('.wheel-plan-container').find('.wheel-plan-name > h4 > .textValue').html(wheelPlanName);

		// Attach basic zoom feature to title
		let wheelPlanImage = this.GetWheelPlanImageName(wheelPlanId);
		let wheelPlanTitle = target.find('.wheel-plan-title');
		if (wheelPlanTitle) {
			wheelPlanTitle.click(function () {
				$('#popupWheelPlan').dialog({
					width: 800,
					height: 800,
					modal: true
				});
				$('#popupWheelPlan').html("<iframe src='" + '/images/WheelPlan/' + wheelPlanImage +
					"' style='height: 100%; width: 100%;' frameborder='0'/>");
			});
		}
	};

	GetVehicleWheelPlanById(wheelPlanId) {
		let vehicle = VehicleClassWheelPlan.plans.find(plan => plan.name === _data.vehicle.class.toLowerCase());		
		var wheelplans;
		if (vehicle != undefined) {
			wheelplans = vehicle.wheelPlans.find(plan => plan.id == wheelPlanId);
		} else {
			for (let index = 0; index < VehicleClassWheelPlan.plans.length; index++) {
				wheelplans = VehicleClassWheelPlan.plans[index].wheelPlans.find(plan => plan.id == wheelPlanId);
			}			
		}		
		return wheelplans;
	}

	GetWheelPlanImageName(wheelPlanId) {
		let _this = this;
		//To do: This method and the above method should not exist as the wheelplan should come from an object.  
		let plan = _this.GetVehicleWheelPlanById(wheelPlanId);
		if (plan !== undefined) return plan.image;
	};

	ActivateWheelPlan(wheelPlanId, wheelPlanName, target) {
		let _this = this;
		// Get an array of SVG shapes representing tyres from image, and an object that
		// can be used to map these IDs to additional properties, like the "Selected setting
		// or a name for the tyre.
		switch (parseInt(wheelPlanId)) {
			case 1: // 4x2
				_this._wheelShapes = _this.GetWheelShapes(target, '#NSF, #NSR, #OSF, #OSR');
				_this._wheelPlan = {
					'NSF': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSF'),
						Position: 'NSF',
						CheckedRadioListIds: []
					},
					'OSF': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSF'),
						Position: 'OSF',
						CheckedRadioListIds: []
					},
					'NSR': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSR'),
						Position: 'NSR',
						CheckedRadioListIds: []
					},
					'OSR': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSR'),
						Position: 'OSR',
						CheckedRadioListIds: []
					},
					'SPARE': {
						Selected: 0,
						Name: _tyresSpecs.getName('SPARE'),
						Position: 'SPARE',
						CheckedRadioListIds: []
					}
				};
				break;
			case 2: // 4x2 Twin
				_this._wheelShapes = _this.GetWheelShapes(target, '#NSF, #NSR, #OSF, #OSR, #NSR2, #OSR2, #SPARE');
				_this._wheelPlan = {
					'NSF': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSF'),
						Position: 'NSF',
						CheckedRadioListIds: []
					},
					'OSF': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSF'),
						Position: 'OSF',
						CheckedRadioListIds: []
					},
					'NSR': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSR') + " Inside",
						Position: 'NSR',
						CheckedRadioListIds: []
					},
					'OSR': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSR') + " Inside",
						Position: 'OSR',
						CheckedRadioListIds: []
					},
					'NSR2': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSR2'),
						Position: 'NSR2',
						CheckedRadioListIds: []
					},
					'OSR2': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSR2'),
						Position: 'OSR2',
						CheckedRadioListIds: []
					},
					'SPARE': {
						Selected: 0,
						Name: _tyresSpecs.getName('SPARE'),
						Position: 'SPARE',
						CheckedRadioListIds: []
					}
				};
				break;
			case 21: // 4x2 Van
				_this._wheelShapes = _this.GetWheelShapes(target, '#NSF, #NSR, #OSF, #OSR');
				_this._wheelPlan = {
					'NSF': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSF'),
						Position: 'NSF',
						CheckedRadioListIds: []
					},
					'OSF': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSF'),
						Position: 'OSF',
						CheckedRadioListIds: []
					},
					'NSR': {
						Selected: 0,
						Name: _tyresSpecs.getName('NSR'),
						Position: 'NSR',
						CheckedRadioListIds: []
					},
					'OSR': {
						Selected: 0,
						Name: _tyresSpecs.getName('OSR'),
						Position: 'OSR',
						CheckedRadioListIds: []
					},
					'SPARE': {
						Selected: 0,
						Name: _tyresSpecs.getName('SPARE'),
						Position: 'SPARE',
						CheckedRadioListIds: []
					}
				};
				break;
			default:
				break;
		}

		// Attach event handlers to elements
		if (_this._wheelShapes.length && $.type(_this._wheelPlan) === 'object') {
			if (_this._wheelShapeOriginalColor === undefined) _this._wheelShapeOriginalColor = _this._wheelShapes[0].style['fill'];

			_this.BindSvgImageControls();
		}
		// Overlay text showing the wheel plan ID and name
		_this.UpdateWheelPlanIdAndName(wheelPlanId, wheelPlanName, target);
	};

	BindSvgImageControls() {
		let _this = this;
		// Reset wheelShapes
		_this.ResetWheelShapes();

		// We have a group of SVG shapes representing the wheels
		_this._wheelShapes.css('cursor', 'pointer');

		_this._wheelShapes.mouseover(function () {
			var wheelShape = $(this);
			var id = wheelShape.prop('id');

			_this.UpdateImageTitle(_this._wheelPlan[id].Name);
			if (!_this._wheelPlan[id].Selected) {
				$(this).css('fill', 'Red');
			}
		});

		_this._wheelShapes.mouseout(function () {
			var wheelShape = $(this);
			var id = wheelShape.prop('id');
			_this.UpdateImageTitle('');
			if (!_this._wheelPlan[id].Selected) {
				$(this).css('fill', '#606161');
			}
		});

		_this._wheelShapes.on('click', function (event) {
			_this.BindWheelShapeEvent(event);
		});
	};

	BindWheelShapeEvent(event) {
		let _this = this;
		// Update "Selected" property of wheel and update fill
		let wheelShape = $(event.target);
		let id = wheelShape.prop('id');
		let activeWheelPlanArray = [];

		if (_this._wheelPlan[id].Selected) {
			wheelShape.css('fill', '#606161');
			wheelShape.attr('data-selected', 'false');
			_this._wheelPlan[id].Selected = 0;

			// Check if current wheelplan has radio button dependencies
			if (_this._wheelPlan[id].CheckedRadioListIds.length) {
				for (let index = 0; index < _this._wheelPlan[id].CheckedRadioListIds.length; index++) {
					var radioValue = _this._wheelPlan[id].CheckedRadioListIds[index];
					$('#' + radioValue).css('fill', '#606161');
					$('#' + radioValue).on('click', _this.BindWheelShapeEvent);
					_this._wheelPlan[radioValue].Selected = 0;
				}
			}
		} else {
			wheelShape.css('fill', 'Blue');
			wheelShape.attr('data-selected', 'true');
			_this._wheelPlan[id].Selected = 1;
			//Turn on the button when a selection is made. 
			var $nextbutton = $('.nextButton');
			if ($nextbutton.is(':hidden')) {
				$nextbutton.show();
			}
			Common.RemoveValidationStyles(undefined, wheelShape.closest('[id^="wheelPlanSection"]'));
		};


	};

	ShowDiagramSelection(wheelPlanId, removeSelectBtn) {
		let _this = this;
		// 1. Hide all diagrams and titles
		$('.tyre-wheelPlan-Column').addClass('d-none');
		// 2. Get hold of selected diagram container
		let $selectedWheelPlan = $('.wheel-plan-container[data-wheelPlanId=' + wheelPlanId + ']').parent();
		// 3. If selection done through inital select button then get rid of them, not needed anymore
		// and display the radio button selection
		if (removeSelectBtn === true) {
			$('.selectWheelPlanBtn').hide();
			$('#wheelPlanSection #carTypeTitle').closest('.row').hide();
			$('#diagramUserInfo').show();
			$('.spareTyreContainer').show();
		}
		// 4. Reduce svg padding
		$selectedWheelPlan.find('svg')
			.css('margin-top', '-30px')
			.css('margin-bottom', '-30px');
		// 5. Show the selected wheelPlan, related info, and next button
		$selectedWheelPlan
			.add('.tyre-selection-info')
			.add($('.nextButton').closest('.card-footer'))
			.add('#tyreDetailColumn')
			.add($selectedWheelPlan)
			.removeClass('d-none')
			.show('slow');

		// 6. hide carousel controls
		$('.carousel-indicators').hide();
		$('.carousel-control-prev').hide();
		$('.carousel-control-next').hide();

		// 7. Activate Wheel Selection and tooltip
		let wheelPlanName = $('input[name="WheelPlan"][value="' + wheelPlanId + '"]').next('label').text();
		//Check we have the name or get it from the VehicleWheelPlan object.
		wheelPlanName = wheelPlanName === '' ? _this.GetVehicleWheelPlanById(wheelPlanId).name : wheelPlanName;
		let diagramTarget = $selectedWheelPlan.find('div[id$="ImageContainer"]');
		_this.ActivateWheelPlan(wheelPlanId, wheelPlanName, diagramTarget);
	};

	HideDiagramSelection() {
		let _this = this;

		// Restore the layout for selecting a wheelplan
		$('.tyre-wheelPlan-Column').removeClass('d-none');
		$('#wheelPlanSection #carTypeTitle').closest('.row').show();
		$('#diagramUserInfo').hide();
		$('.selectWheelPlanBtn').show();
		$('.carousel-indicators').show();
		$('.carousel-control-prev').show();
		$('.carousel-control-next').show();
		$('.spareTyreContainer').hide();
		$('.tyre-selection-info').hide();

		// Re-set the image margins, which are modified when a wheelplan is
		// selected
		$('.tyre-wheelPlan-Column').find('svg')
			.css('margin-top', '0px')
			.css('margin-bottom', '0px');
		_this._wheelShapes.css('cursor', 'default');

		// De-activate diagram, so tyre cannot be selected until a wheelplan has
		// been chosen.
		_this.ResetWheelShapes();

		// Change data-selected value of all svg rect objects (the tyres) to false
		$('#wheelPlanSection [data-wheelplanid="' + _data.vehicle.wheelPlan + '"] rect').each(function (index) {
			$(this).attr('data-selected', 'false');
		});

		// We have effectively de-selected a tyre, so clear wheel plan and any selected tyres
		for (let property in _this._wheelPlan) {
			_this._wheelPlan[property].Selected = 0;
		}
		_data.vehicle.wheelPlan = null;
		_data.vehicle.wheelsSelected = null;
	}
	// --------------------------------------------------
	// PUBLIC FUNCTIONS
	// --------------------------------------------------

	GetValidator() {
		var validator = $('#wheelPlanSection').kendoValidator({
			rules: {
				mandatoryVehicleSelection: function (input) {
					let wheelPlanSelected = $.isNumeric(_data.vehicle.wheelPlan);
					if (!wheelPlanSelected) {
						return false;
					} else {
						// Only validate tyre posisitons which are present in the currently selected wheelplan 
						var anyWheelChecked = $('#wheelPlanSection [data-wheelplanid="' + _data.vehicle.wheelPlan + '"] rect')
							.filter('[data-selected="true"]').length > 0;
						var spare = $('#wheelPlanSection [data-wheelplanid="' + _data.vehicle.wheelPlan + '"] .changeSpareRadio').is(":checked");
						if (!anyWheelChecked && !spare) {
							return false;
						}
					}
					return true;
				}
			},
			messages: {
				mandatoryVehicleSelection: 'Please select at least 1 wheelplan and 1 tyre.'
			}
		}).data('kendoValidator');

		validator.bind('validate', function (e) {
			let $invalidInputs = $(e.sender.element).find('.k-invalid');

			let wheelPlanselected = $invalidInputs.filter('[name="WheelPlan"]').length > 0;
			if (wheelPlanselected) {
				$('.wheel-plan-container').addClass('tyreDetailInvalid');
			} else {
				$('.wheel-plan-container').removeClass('tyreDetailInvalid');
			}
		});

		return validator;
	};


	async GetLatestTyreFittingsDataSource(vehicleRegistration) {
		return await this.GetLatestTyreFittings(vehicleRegistration);
	}

	async GetLatestTyreFittings(vehicleRegistration) {
		let result = $.Deferred();

		let queryString = Common.GetQueryStringValue('q', null);
		let url = '/vehicle/latesttyrespecifichistory?q=' + queryString + '&vehicleRegistration=' + vehicleRegistration;

		$.ajax({
			url: url,
			type: 'GET',
			cache: false,
			success: function (data) {
				result.resolve(data);
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(thrownError);
			},
			complete: function () {

			}
		});

		return result.promise();
	}

	async Initialise(disableSection, enableSection) {
		$('.nextButton').hide();

		// need to set tyre history before we use on next section
		if (_data._vehicle._tyreHistory === null) {
			const registration = $('#vehicle-search-input').val().replace(' ', '').toUpperCase();
			_data.vehicle.tyreHistory = JSON.parse(await this.GetLatestTyreFittingsDataSource(registration));

			// re-order the history so '[New]' are at tops
			_data.vehicle.tyreHistory.sort(function (a, b) {
				let newItem = a.newExisting;
				let existingItem = b.newExisting;
				if (newItem < existingItem) {
					return 1;
				}
				if (newItem > existingItem) {
					return -1;
				}

				//equal
				return 0;
			})	
		}

		this.BuildWheelPlanDom()
			.then(() => {
				this.BindControls();
				this.InitialiseWheelPlanImages();
			}).finally(() => {
				//Show the panel
				this.disableSection = (sectionName) => {
					disableSection(sectionName);
				};
				this.enableSection = (sectionName) => {
					enableSection(sectionName);
				};	
			});
	};
}

export let _wheelPlansPanel = new WheelPlans();
